import { PayloadAction } from '@reduxjs/toolkit';

import { FontState, UploadedFontData } from 'editor/src/store/fonts/types';

const addUploadedFontsReducer = (state: FontState, action: PayloadAction<UploadedFontData[]>) => {
  const existingFontFiles = new Set(state.uploadedFonts.map((f) => f.fontFile));
  const existingFilenames = new Set(state.uploadedFonts.map((f) => f.filename.toLowerCase()));
  const newFonts = action.payload.filter(
    (f) => !existingFontFiles.has(f.fontFile) && !existingFilenames.has(f.filename.toLowerCase()),
  );
  state.uploadedFonts = [...newFonts, ...state.uploadedFonts];
};

export default addUploadedFontsReducer;
